export function useVideo() {
    function getVimeoId(url) {
        const regEx = /vimeo\.com\/(?:video\/|manage\/videos\/)?(\d+)/;
        const match = url.match(regEx);

        return match ? match[1] : null;
    }

    return {
        getVimeoId
    };
}